import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import HomeIcon from '@icons/HomeIcon';

export default function HomeButton(props: any) {
	const {t} = useTranslation();
	
	return (
		<Link to="/" {...props}>
			<Stack direction="column" alignItems="center" spacing={0.5}>
				<HomeIcon active={props['aria-selected']}/>
				<Typography fontSize={12}>{t('home')}</Typography>
			</Stack>
		</Link>
	);
}
